;(function (angular) {
  'use strict'

  angular.module('kilo.routes.product-pack.list', [])
  .config(RouteConfigurator)

  function RouteConfigurator ($stateProvider) {
    var listState = {
      name: 'product-pack.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'PACKS PRODUITS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('productPackList')
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/list/templates/product-pack-list.template.html',
          controller: 'ProductPackListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product-pack/list/templates/product-pack-list-toolbar.template.html',
          controller: function () {},
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Packs Produits'
      }
    }
    $stateProvider.state(listState)
  }
})(window.angular)
